import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCalendarSaveIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17 13.75C17.4142 13.75 17.75 14.0858 17.75 14.5V18.7002L19.125 17.9072C19.4837 17.7001 19.9423 17.823 20.1494 18.1816C20.3565 18.5403 20.2337 18.9989 19.875 19.2061L17.375 20.6494C17.143 20.7834 16.857 20.7834 16.625 20.6494L14.125 19.2061C13.7663 18.9989 13.6435 18.5403 13.8506 18.1816C14.0577 17.823 14.5163 17.7001 14.875 17.9072L16.25 18.7002V14.5C16.25 14.0858 16.5858 13.75 17 13.75Z",
			fill: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 17.25C9.91421 17.25 10.25 17.5858 10.25 18C10.25 18.4142 9.91421 18.75 9.5 18.75H6.5C6.08579 18.75 5.75 18.4142 5.75 18C5.75 17.5858 6.08579 17.25 6.5 17.25H9.5Z",
			fill: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 12.25C9.91421 12.25 10.25 12.5858 10.25 13C10.25 13.4142 9.91421 13.75 9.5 13.75H6.5C6.08579 13.75 5.75 13.4142 5.75 13C5.75 12.5858 6.08579 12.25 6.5 12.25H9.5Z",
			fill: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V3.25H18.998C20.5176 3.25 21.7491 4.48244 21.748 6.00195L21.7451 9.50098L21.748 13.4375C22.6838 14.5301 23.25 15.9486 23.25 17.5C23.25 20.9518 20.4518 23.75 17 23.75C15.7505 23.75 14.5878 23.3816 13.6113 22.75H5C3.48124 22.75 2.25005 21.5187 2.25 20V6C2.25 4.48122 3.48122 3.25 5 3.25H7.25V2C7.25 1.58579 7.58579 1.25 8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V3.25H15.25V2C15.25 1.58579 15.5858 1.25 16 1.25ZM17 12.75C14.3766 12.75 12.25 14.8766 12.25 17.5C12.25 20.1234 14.3766 22.25 17 22.25C19.6234 22.25 21.75 20.1234 21.75 17.5C21.75 14.8766 19.6234 12.75 17 12.75ZM3.75 20C3.75005 20.6903 4.30967 21.25 5 21.25H12C11.2153 20.2054 10.75 18.9071 10.75 17.5C10.75 14.0482 13.5482 11.25 17 11.25C18.1893 11.25 19.3007 11.5826 20.2471 12.1592L20.2451 10.25H3.75V20ZM5 4.75C4.30964 4.75 3.75 5.30964 3.75 6V8.75H20.2461L20.248 6.00098C20.2486 5.31025 19.6888 4.75 18.998 4.75H16.75V6C16.75 6.41421 16.4142 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6V4.75H8.75V6C8.75 6.41421 8.41421 6.75 8 6.75C7.58579 6.75 7.25 6.41421 7.25 6V4.75H5Z",
			fill: "#30515B"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedCalendarSaveIcon);
const Memo = memo(ForwardRef);
export default Memo;
